module.exports = __webpack_public_path__ + "media/images/fr_ca/relationships-segment-f0eda95c760b5301c6b4ca359b0f3142.jpg";